module.exports = __webpack_public_path__ + "img/shaman_small.2bd83b35.png";